import { ArrowDownRight, Sparkles, Box, FileText, Hammer } from "lucide-react";
import { trackClick } from "@/lib/analytics";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_ai-interior-viz-1/artifacts/kng796z0_kamar%20mandi%20AT%20Studio.png";

const chips = [
  { icon: Box, label: "Desain 3D" },
  { icon: FileText, label: "RAB Lengkap" },
  { icon: Hammer, label: "Build Premium" },
];

export default function Hero() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-32 bg-gradient-to-br from-white via-sky-50 to-cyan-50"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 fade-up">
          <div className="flex items-center gap-3 mb-8 text-sky-600">
            <Sparkles size={16} />
            <span className="text-xs uppercase tracking-[0.3em] font-semibold">Studio Desain & Build Interior Berbasis AI</span>
          </div>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-[0.95] text-slate-900">
            Studio Desain<br />
            <span className="italic bg-gradient-to-r from-sky-500 to-cyan-500 bg-clip-text text-transparent">
              & Build Interior
            </span><br />
            Premium berbasis AI.
          </h1>
          <p className="mt-8 text-base lg:text-lg text-slate-600 max-w-xl font-light leading-relaxed">
            Dari ide hingga eksekusi — kami menerjemahkan visi ruangan Anda menjadi kenyataan.
            <span className="block mt-2 text-slate-500">Pesan <b>Desain 3D</b>, <b>RAB</b>, dan <b>premium interior</b> dalam satu studio terintegrasi.</span>
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {chips.map((c) => (
              <div
                key={c.label}
                className="flex items-center gap-2 px-4 py-2 bg-white border border-sky-100 rounded-full text-sm text-slate-700 shadow-sm"
              >
                <c.icon size={14} className="text-sky-500" />
                {c.label}
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-upload"
              onClick={() => { trackClick("hero_generate_design"); scrollTo("upload"); }}
              className="group inline-flex items-center gap-3 bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white font-semibold text-sm uppercase tracking-[0.2em] px-8 py-5 rounded-full shadow-xl shadow-sky-200 transition-all"
            >
              Generate Desain Saya
              <ArrowDownRight size={18} className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-consultation"
              onClick={() => { trackClick("hero_consultation"); scrollTo("konsultasi"); }}
              className="inline-flex items-center gap-3 bg-white text-slate-800 border border-slate-200 hover:border-sky-300 hover:text-sky-600 text-sm uppercase tracking-[0.2em] px-8 py-5 rounded-full transition-colors"
            >
              Konsultasi Gratis
            </button>
          </div>

          <div className="mt-14 grid grid-cols-3 max-w-2xl gap-8 border-t border-slate-200 pt-8">
            <div>
              <div className="font-display text-3xl lg:text-4xl text-sky-600">+250</div>
              <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-2">Proyek selesai</div>
            </div>
            <div>
              <div className="font-display text-3xl lg:text-4xl text-sky-600">5 mnt</div>
              <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-2">Generate AI</div>
            </div>
            <div>
              <div className="font-display text-3xl lg:text-4xl text-sky-600">4.9★</div>
              <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mt-2">Rating klien</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 fade-up relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl shadow-sky-200/60 border border-white">
            <img src={HERO_IMG} alt="Bathroom classic modern" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute bottom-4 left-4 right-4 glass rounded-2xl p-4">
              <div className="text-[10px] uppercase tracking-[0.25em] text-sky-600 font-semibold">Karya Pilihan</div>
              <div className="font-display text-lg text-slate-900 mt-1">Bathroom Klasik Modern</div>
              <div className="text-xs text-slate-600">Marble Carrara · BSD Tangerang Selatan</div>
            </div>
          </div>
          <div className="absolute -top-6 -right-6 w-32 h-32 bg-gradient-to-br from-sky-400/30 to-cyan-300/30 rounded-full blur-3xl -z-10" />
          <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-gradient-to-br from-cyan-300/40 to-sky-200/40 rounded-full blur-3xl -z-10" />
        </div>
      </div>
    </section>
  );
}
